<div class="table-responsive mt-3">
    <table  aria-labelledby="taxonomyTitle" class="table table-hover data-table data-table-advance">
        <thead>
            <tr>
                <th scope="col">TAXONOMY TITLE</th>
                <th scope="col">UUID</th>
                <th scope="col">NODE TYPE</th>
                <th scope="col">HUMAN CODING SCHEME</th>
                <th scope="col">FULL<br>STATEMENT</th>
                <th scope="col">COURSE<br>DESCRIPTION</th>
                <th scope="col">PUBLISHED</th>
            </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="(allSourceData && allSourceData.length === 0)">
            <tr role="row" class="tr">
            <td colspan="7" role="gridcell" class="text-center" >
              No Data Found
            </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="allSourceData && allSourceData.length >0">
            <tr *ngFor="let product of allSourceData | slice:startIndex:lastIndex; let i = index">
              <td><a href="javascript:void(0);"  (click)="onTaxonomtDetail(product)" aria-label="[Opens in new window]"  [innerHtml]="product._index == 'cfitems'? product._source.CFDocumentURI.title : product._source.title"></a></td>
              <td>{{ product._source.identifier}}</td>
              <td>{{ product._index == 'cfitems'? product._source.CFItemTypeURI.title :  product._source.nodeType }}</td>
              <td>{{ product._index == 'cfitems'? product._source.humanCodingScheme : ''}} </td>
              <td><a href="javascript:void(0);" (click)="onTaxonomyDetailItem(product)" aria-label="[Opens in new window]" [innerHtml]="product._index == 'cfitems'? product._source.fullStatement : '' "></a></td>
              <!-- <td>{{product._index == 'cfitems'? '' : ((product._source.description && product._source.description != 'undefined') ? product._source.description : '')}}</td> -->
              <td [innerHtml]="((product._source.course_description && product._source.course_description != 'undefined') ? product._source.course_description : '')"></td>
              <td>{{product._source.lastChangeDateTime |  date: 'dd/MM/yyyy'}}</td>
          </tr>
          </ng-container>

        </tbody>
    </table>
</div>
<app-preloader [loaderText]=" 'Loading ...'" *ngIf="showLoaderAdvsearch" style="left: 0;" class="preloader-backdrop position-fixed w-100 h-100"></app-preloader>

<!-- <app-pagination *ngIf="allSourceData && allSourceData.length >0 " #paginationRef [dataLength]="allListValueCount" (displayItemRangeEvent)="showDataInRange($event)" [defaultPageRange]="pagination">
</app-pagination> -->
<app-pagination *ngIf="(allSourceData && allSourceData.length !== 0)" [style.display]="showLoaderAdvsearch ? 'none' : ''"  #paginationRef [dataLength]="allListValueCount" (displayItemRangeEvent)="showDataInRange($event)" [defaultPageRange]="pagination">
</app-pagination>